import {btn, fieldset, form, Notifier, tbar, TextField, textfield, Window} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {ServerApi} from "./util/ServerApi.js";
import {IfwInvalidator} from "./util/IfwInvalidator.js";

export class PasswordUpdateDialog extends Window {

	private oldPasswordFld: TextField;
	private passwordFld: TextField;
	private passwordConfirmFld: TextField;

	constructor() {
		super();
		this.title = t("Change password");
		this.modal = true;
		this.width = 600;
		this.maximizable = false;
		this.closable = true;
		this.draggable = false;
		this.resizable = false;

		const f = form({
				flex: 1,
				handler: async () => {
					const v = f.value, pwFld = this.passwordFld;
					const url = ServerApi.url("elearning/frontend/participants/current/changePassword");
					ServerApi.call(url, {oldPass: v.oldPassword, newPass: v.password}, "POST")
						.then(response => {
							if (response.success) {
								// All done
								Notifier.success(t("Your password has been changed"), 3000);
								this.close();
								return;
							}
							if (response.data && response.data.validationErrors) {
								IfwInvalidator.setInvalidPasswordMessage(pwFld, response.data.validationErrors.password);
							} else {
								// Simply wrong password
								this.oldPasswordFld.setInvalid(t("The password is incorrect"));
							}
						})
						.catch((reason) => {
							if(reason.type == "invalidProperties") {
								IfwInvalidator.setInvalidPasswordMessage(this.passwordFld, reason.validationErrors["password"]);
							} else {
								void Window.error(reason);
							}
							this.passwordFld.focus();
						});
				}
			},
			fieldset({
					flex: 1,
				},
				this.oldPasswordFld = textfield({
					label: t("Old Password"),
					name: "oldPassword",
					id: "oldPassword",
					type: "password",
					required: true,
					autocomplete: "off",
					listeners: {
						change: ({newValue}) => {
							const dupe = this.passwordConfirmFld.value;
							if (dupe && dupe !== newValue) {
								this.passwordConfirmFld.setInvalid(t("The passwords don't match"));
							}
						},
					}
				}),

				this.passwordFld = textfield({
					label: t("Password"),
					name: "password",
					id: "password",
					type: "password",
					required: true,
					hint: t("strongRuleSetText"), // To be overwritten in the render event handler
					autocomplete: "off",
					listeners: {
						change: ({newValue}) => {
							const dupe = this.passwordConfirmFld.value;
							if (dupe && dupe !== newValue) {
								this.passwordConfirmFld.setInvalid(t("The passwords don't match"));
							}
						},
					}
				}),

				this.passwordConfirmFld = textfield({
					label: t("Repeat Password"),
					name: "repeatPass",
					id: "repeatPass",
					type: "password",
					required: true,
					autocomplete: "off",
					listeners: {
						change: ({target, newValue}) => {
							const dupe = this.passwordFld.value;
							if (dupe && dupe !== newValue) {
								target.setInvalid(t("The passwords don't match"))
							}
						},
					}
				})
			),
			tbar({cls: "ifw-bbar"}, "->",
				btn({html: t("Change"), type: "submit"})
			)
		); //form

		this.items.add(f);

		this.on("beforerender", async  () => {
			const portalConfig = JSON.parse(localStorage.getItem("portalConfig")!);
			this.passwordFld.hint = t(portalConfig.activePasswordRuleSet + "RuleSetText");
		});
	}
}